module.exports = __webpack_public_path__ + "img/gnome_4.dde6c97f.png";